const tileRoofing = [
  {
    question: "What are tile roofs made of?",
    answer:
      "Tile roofs are typically made from clay, concrete, or composite materials<IN_CITY_ZIP>. These materials offer excellent fire resistance, weather durability, and long-term performance in California's climate.",
  },
  {
    question: "How long does a tile roof last?",
    answer:
      "Properly installed tile roofs can last 50 years or more<IN_CITY_ZIP>. Clay and concrete tiles are among the most durable roofing options, especially in dry or sun-heavy areas like Southern California.",
  },
  {
    question: "Do I need a permit to install or replace a tile roof?",
    answer:
      "Yes. All tile roof replacements or new installations<IN_CITY_ZIP> require city permits and inspections. Modern Build handles the entire permitting process to ensure full code compliance.",
  },
  {
    question: "How long does it take to install a tile roof?",
    answer:
      "Most tile roof installations<IN_CITY_ZIP> take 5 to 10 days depending on roof size, slope, material, and weather. We provide a detailed schedule before we begin the project.",
  },
  {
    question: "Are tile roofs good for hot climates?",
    answer:
      "Yes. Tile roofs are ideal for hot climates<IN_CITY_ZIP> due to their thermal mass, which helps insulate the home and reduce air conditioning usage during warm months.",
  },
  {
    question: "What types of tile roofs do you install?",
    answer:
      "We install clay, concrete, and composite tile roofing<IN_CITY_ZIP> in styles like Spanish, mission, flat, and S-curved profiles. Our team helps you choose the best fit for your home’s architecture.",
  },
  {
    question: "Can a tile roof be installed over an existing roof?",
    answer:
      "In most cases, no. Tile roofs are heavy and typically require removing the old roof<IN_CITY_ZIP>. We assess your roof deck and structure to determine what’s safe and up to code.",
  },
  {
    question: "How much does a tile roof cost?",
    answer:
      "Tile roof installation costs<IN_CITY_ZIP> typically range from $15,000 to $30,000+, depending on tile type, roof size, slope, and any structural reinforcement needed. We offer free estimates customized to your home.",
  },
  {
    question: "Are warranties available on tile roofing systems?",
    answer:
      "Yes. We offer manufacturer warranties on the tile material and underlayment, as well as our own workmanship guarantee<IN_CITY_ZIP>. Warranty terms vary based on your material selection.",
  },
  {
  question: "Do tile roofs require a lot of maintenance?",
  answer:
    "Tile roofs are low-maintenance compared to other roofing types<IN_CITY_ZIP>. Periodic inspections to check for cracked or displaced tiles, especially after storms, help maintain their integrity and appearance.",
  },
  {
    question: "Can broken or cracked tiles be replaced individually?",
    answer:
      "Yes. One of the benefits of tile roofing<IN_CITY_ZIP> is that damaged tiles can usually be replaced individually without redoing the entire roof, making repairs more affordable and efficient.",
  },
  {
    question: "Are tile roofs eco-friendly?",
    answer:
      "Yes. Clay and concrete tiles are often made from natural or recyclable materials<IN_CITY_ZIP>. Their long lifespan and energy efficiency make them an environmentally friendly roofing option.",
  },
];

export default tileRoofing;
